import { gaTracking, getCurrentPageLocation, normalizeString } from "../../lib/ga";
import type { GAFormName } from "../../types/ga";

/**
 * Tracks form start events
 * @param formName - Name of the form being started
 * @param formSubject - Optional subject/topic of the form
 * @see /GAExamples/form_start.js
 */
export const trackFormStart = (formName: GAFormName | string, formSubject?: string): void => {
  gaTracking({
    event: "form_start",
    event_parameters: {
      page_location: getCurrentPageLocation(),
      form_name: formName,
      subject: normalizeString(formSubject) ?? undefined,
    },
  });
};

/**
 * Tracks form submit events
 * @param formName - Name of the form being submitted
 * @param formSubject - Optional subject/topic of the form (can be array)
 * @see /GAExamples/form_submit.js
 */
export const trackFormSubmit = (
  formName: GAFormName | string,
  formSubject?: string | string[],
): void => {
  gaTracking({
    event: "form_submit",
    event_parameters: {
      page_location: getCurrentPageLocation(),
      form_name: formName,
      subject:
        typeof formSubject === "string" ? (normalizeString(formSubject) ?? undefined) : formSubject,
    },
  });
};
